export default "__VITE_ASSET__Dwra5YKt__"